import { render, staticRenderFns } from "./douyinShopGoodsItem.vue?vue&type=template&id=2d843364&scoped=true"
import script from "./douyinShopGoodsItem.vue?vue&type=script&lang=js"
export * from "./douyinShopGoodsItem.vue?vue&type=script&lang=js"
import style0 from "./douyinShopGoodsItem.vue?vue&type=style&index=0&id=2d843364&prod&scoped=true&lang=css"
import style1 from "./douyinShopGoodsItem.vue?vue&type=style&index=1&id=2d843364&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d843364",
  null
  
)

export default component.exports